'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function sumBy(items, getValue) {
    var result = 0;
    for(var i = 0; i < items.length; i++){
        result += getValue(items[i], i);
    }
    return result;
}
exports.sumBy = sumBy;
